import en from './translations/en';

export const t = (translationPath, replacementVar = '') => {
    let cur = en;

    for (let path of translationPath.split('.')) {
        if (typeof cur[path] === 'undefined') {
            return translationPath;
        }

        cur = cur[path];
        if (typeof cur === 'string') {
            if (cur.includes('{{') && cur.includes('}}')) {
                const regex = /\{\{(\w+)\}\}/g;
                return cur.replace(regex, (match, p1) => {
                    return replacementVar[p1] !== undefined
                        ? replacementVar[p1]
                        : match;
                });
            }
            return cur;
        }
    }
};
